import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Stack } from "@mui/material";
import Typography from "../Common/CprimeText";
import CprimeLink from "../Common/CprimeLink";

const BreadcrumbsSx = {
  "& .MuiBreadcrumbs-separator": {
    color: "black !important",
  },
  "& .MuiBreadcrumbs-li": { display: "flex" },
  "& .MuiSvgIcon-root": {
    fontSize: "1rem",
  },
  "& .MuiStack-root": { marginRight: "4px !important" },
  "& .MuiTypography-root": {
    height: "21px !important",
    fontSize: "14px !important",
  },
  "& .MuiTypography-root.MuiLink-root": {
    color: "#2469FF !important",
  },
};

function CustomBreadcrumb({ items, sx = BreadcrumbsSx }: any) {
  return (
    <Breadcrumbs sx={sx}>
      {items.map((item: any, index: any) => (
        <Stack direction="row" alignItems="center" key={index}>
          {item.icon && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "4px",
              }}
            >
              {item.icon}
            </span>
          )}
          {item.href ? (
            <CprimeLink
              to={item.href}
              state={item.state}
              underline="hover"
              color="inherit"
            >
              {item.label}
            </CprimeLink>
          ) : item.onClick ? (
            <CprimeLink
              component="button"
              type="button"
              onClick={item.onClick}
              underline="hover"
              color="inherit"
              sx={{ cursor: "pointer", border: 0, background: "none", padding: 0 }}
            >
              {item.label}
            </CprimeLink>
          ) : (
            <Typography color="text.primary">{item.label}</Typography>
          )}
        </Stack>
      ))}
    </Breadcrumbs>
  );
}

export default CustomBreadcrumb;
